module.exports = __webpack_public_path__ + "static/media/collums.efe80ddd.ico";